import styled from 'styled-components/macro';

const SpinnerWrapper = styled.div`
  display: flex;
  height: 100vh;
  align-items: center;
`;

export default SpinnerWrapper;
